import type { UserPreferences } from '@/core/models/preferences';
import { normalizePreferences } from '@/core/services/prefsService';
import { ALL_APPEARANCE_KEYS, appearanceValues } from './appearanceCategories';

export interface SavedLook {
  id: string;
  name: string;
  values: Partial<UserPreferences>;
}
const key = (owner: string) => `truxsocial:appearance-looks:${owner}`;
export function readLooks(owner: string): SavedLook[] {
  try {
    const records: unknown = JSON.parse(localStorage.getItem(key(owner)) ?? '[]');
    if (!Array.isArray(records)) return [];
    const seen = new Set<string>();
    return records
      .flatMap((record) => {
        if (
          !record ||
          typeof record.id !== 'string' ||
          seen.has(record.id) ||
          typeof record.name !== 'string' ||
          !record.name.trim() ||
          !record.values ||
          typeof record.values !== 'object'
        )
          return [];
        seen.add(record.id);
        return [
          {
            id: record.id,
            name: record.name.trim().slice(0, 40),
            values: appearanceValues(ALL_APPEARANCE_KEYS, normalizePreferences(record.values)),
          },
        ];
      })
      .slice(0, 12);
  } catch {
    return [];
  }
}
export function writeLooks(owner: string, looks: SavedLook[]): boolean {
  try {
    localStorage.setItem(key(owner), JSON.stringify(looks));
    return true;
  } catch {
    return false;
  }
}
